import React, { useState } from 'react';
import styles from './FeaturedProjects.module.css';

const FeaturedProjects = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const projectsData = [
        {
            id: 1,
            title: "Supply, Design, Engineering & Installation of 400/220/132/33kV ",
            company: "GIS Substation at Sector–148, Noida.",
            image: "/images/substation.jpg",
            type: "substation"
        },
        {
            id: 2,
            title: "Supply, Design, Engineering & Installation of 400/132/33kV", 
            company: "GIS Substation at Sector– 123,Noida",
            image: "/images/substation2.jpg",
            type: "substation"
        },
        {
            id: 3,
            title: "Supply of 132kV Underground Cable Installation at Allahabad",
            company: "From GIS Power house S/S to 220kV Cant. S/S",
            image: "/images/substation3.jpg",
            type: "underground"
        },
        {
            id: 4,
            title: "Supply and Erection for 132kV 2-Phase underground XLPE cable ",
            company: "Along with 400mm² Aluminum conductor Ramsanehi Ghat – Budhwal TSS Transmission Line",
            image: "/images/substation4.jpg",
            type: "transmission"
        },
        {
            id: 5,
            title: "E&M works for Railways Tunnels (T-40 to T-47)",
            company: "For Tunnel T-40/41, T-42/43,T-44/45,T-46 & T/47 in Katra– Dharam section of Udhampur–Srinagar- Baramulla rail link project",
            image: "/images/railwaytunnel.jpg",
            type: "tunnel"
        },
        {
            id: 6,
            title: "E&M works for Railways Tunnels (T-6 to T-12)",
            company: "For Tunnel T-6, T-9,T-10,T-11 &T-12 in Katra– Dharam section of Udhampur– Srinagar- Baramullarail link project",
            image: "/images/railwaytunnel2.jpg",
            type: "tunnel"
        },
        {
            id: 7,
            title: "Supply of 132kV Single Core 630 sq. mm Aluminum Conductor Corrugated XLPE cable",
            company: "For 132kV DC FCI- Bhathat Cable Line Gorakhpur",
            image: "/images/substation7.jpg",
            type: "substation"
        },
        {
            id: 8,
            title: "Supply and Erection of 1 Nos of 132kV Hybrid Switchgear Bay Installation",
            company: "For bus coupler at 220/132/33kV Substation, Sec-62, Noida",
            image: "/images/substation8.jpg",
            type: "electrical"
        }
    ];

    const itemsPerSlide = 3;
    const totalSlides = Math.ceil(projectsData.length / itemsPerSlide);

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % totalSlides);
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
    };

    const getCurrentProjects = () => {
        const startIndex = currentSlide * itemsPerSlide;
        return projectsData.slice(startIndex, startIndex + itemsPerSlide);
    };

    return (
        <section className={styles.featuredProjectsSection}>
            <div className={styles.container}>
                <div className={styles.sectionHeader}>
                    <div className={styles.headerContent}>
                        <h2 className={styles.sectionTitle}>Key <span className={styles.bluelabel}>Projects</span></h2>
                        <p className={styles.sectionDescription}>
                            Our recent projects exemplify a paradigm shift in innovation and 
                            execution, redefining success with their flawless implementation.
                        </p>
                    </div>
                    
                    <div className={styles.navigationControls}>
                        <button 
                            onClick={prevSlide} 
                            className={styles.navButton}
                            disabled={currentSlide === 0}
                            aria-label="Go to previous set of projects"
                            type="button"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </button>
                        <button 
                            onClick={nextSlide} 
                            className={styles.navButton}
                            disabled={currentSlide === totalSlides - 1}
                            aria-label="Go to next set of projects"
                            type="button"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </button>
                    </div>
                </div>

                <div className={styles.projectsCarousel}>
                    <div className={styles.projectsGrid}>
                        {getCurrentProjects().map((project) => (
                            <div key={project.id} className={styles.projectCard}>
                                <div className={styles.projectImageContainer}>
                                    <img 
                                        src={project.image} 
                                        alt={project.title}
                                        className={styles.projectImage}
                                    />
                                    {/* <div className={styles.projectOverlay}>
                                        <div className={styles.projectArrow}>
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                <path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </div>
                                    </div> */}
                                </div>
                                
                                <div className={styles.projectContent}>
                                    <h3 className={styles.projectTitle}>{project.title}</h3>
                                    <p className={styles.projectCompany}>{project.company}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Slide indicators */}
                <div className={styles.slideIndicators} role="tablist" aria-label="Project slides">
                    {Array.from({ length: totalSlides }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => setCurrentSlide(index)}
                            className={`${styles.indicator} ${
                                currentSlide === index ? styles.indicatorActive : ''
                            }`}
                            role="tab"
                            aria-selected={currentSlide === index}
                            aria-label={`Go to slide ${index + 1} of ${totalSlides}`}
                            type="button"
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FeaturedProjects;
